export const propertyData = {
  name: "Royal Heights Residency",
  tagline: "Where Luxury Life Blends With Serenity",
  location: "Prime Location, City Center",
  reraNumber: "RERA Registration No: P02400009393",
  
  hero: {
    slides: [
      {
        id: 1,
        image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=1920&q=80",
        title: "Royal Heights",
        subtitle: "Prime Location, City Center"
      },
      {
        id: 2,
        image: "https://images.unsplash.com/photo-1512917774080-9991f1c4c750?w=1920&q=80",
        title: "Luxury Redefined",
        subtitle: "Ultra-Premium 4 BHK Apartments"
      }
    ],
    unitType: "4 BHK",
    subtitle: "Luxury Apartments",
    price: "₹ 7.00 Cr*",
    priceSubtext: "Onwards*"
  },

  overview: {
    title: "Overview",
    description: `**Discover Royal Heights Residency** — a landmark in luxury living, where sophistication meets innovation. Nestled in a prime location, this prestigious project presents expansive 4 BHK residences adorned with futuristic home automation and world-class amenities.

**Developed by Premium Developers**, a trusted name in real estate, Royal Heights is a masterclass in elegance, blending modern comfort, premium interiors, and architectural excellence. Every detail is thoughtfully designed to deliver an exceptional living experience — one that exudes style, serenity, and status.

**Live elevated. Live iconic.**`,
    details: [
      { label: "Unit Type", value: "4 BHK Uber Luxury Apartments" },
      { label: "Price Range", value: "₹ 7.00 Cr*" },
      { label: "Super Built-Up Area", value: "3,500 - 5,000 Sq.Ft." },
      { label: "Location", value: "Prime Location, City Center" }
    ]
  },

  beacon: {
    title: "THE BEACON OF EXCLUSIVITY",
    stats: [
      { value: "10", label: "Acres Site Area" },
      { value: "3", label: "Towers" },
      { value: "35", label: "Floors" },
      { value: "180", label: "Uber-Luxury Residences" },
      { value: "50,000 SQ. FT.", label: "Clubhouse & Amenities" }
    ],
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&q=80"
  },

  floorPlans: {
    masterPlan: "../image/floorplan/master_plan.webp",
    towers: [
      {
        name: "Msn one Master plan",
        image: "../image/floorplan/master.webp"
      },
      {
        name: "Tower AON &UNOW",
        image: "../image/floorplan/floor1.webp"
      },
      {
        name: "Tower ISA",
        image: "../image/floorplan/floor1.webp"
      },
      {
        name: "Tower EKA & ODIN",
        image: "../image/floorplan/floor3.webp"
      },
    ]
  },

  gallery: [
    { id: 1, url: "../image/prop1.webp", alt: "Exterior View" },
    { id: 2, url: "../image/prop3.webp", alt: "Living Room" },
    { id: 3, url: "../image/prop4.webp", alt: "Bedroom" },
    { id: 4, url: "../image/prop5.webp", alt: "Kitchen" },
    { id: 5, url: "../image/prop6.webp", alt: "Bathroom" },
    { id: 6, url: "../image/prop7.webp", alt: "Amenities" },
    { id: 7, url: "../image/prop8.webp", alt: "Pool" },
    { id: 8, url: "../image/prop9.webp", alt: "Clubhouse" },
    { id: 9, url: "../image/prop11.webp", alt: "Garden" },
    { id: 10, url: "../image/prop12.webp", alt: "Night View" },
    { id: 11, url: "../image/top_side_view.jpeg", alt: "Entrance" }
  ],

  downloads: [
    { icon: "FileText", title: "Brochure", label: "DOWNLOAD" },
    { icon: "LayoutGrid", title: "Floor Plan", label: "DOWNLOAD" },
    { icon: "Map", title: "Site Plan", label: "DOWNLOAD" }
  ],

  locationDetails: {
    address: "Prime Location, City Center",
    sections: [
      {
        icon: "MapPin",
        title: "STRATEGIC CONNECTIVITY",
        items: [
          "Outer Ring Road (ORR) – 5 Mins*",
          "International Airport – 30–35 Mins*",
          "Financial District – 10–15 Mins*"
        ]
      },
      {
        icon: "ShoppingCart",
        title: "LEISURE & ENTERTAINMENT",
        items: [
          "Premium Mall – 20–25 Mins*",
          "Sports Stadium – 15–20 Mins*",
          "Entertainment Hub – 20–25 Mins*"
        ]
      },
      {
        icon: "GraduationCap",
        title: "SCHOOLS & INSTITUTES",
        items: [
          "International School – 10–15 Mins*",
          "Business School – 10–15 Mins*",
          "University – 20–25 Mins*"
        ]
      },
      {
        icon: "Building",
        title: "IT HUBS",
        items: [
          "Tech City – 20–25 Mins*",
          "IT Park – 15–20 Mins*",
          "Business District – 20–25 Mins*"
        ]
      }
    ],
    connectivity: [
      {
        icon: "MapPin",
        place: "Outer Ring Road (ORR)",
        distance: "5 Mins*"
      },
      {
        icon: "Plane",
        place: "International Airport",
        distance: "30–35 Mins*"
      },
      {
        icon: "Building",
        place: "Financial District",
        distance: "10–15 Mins*"
      },
      {
        icon: "ShoppingCart",
        place: "Premium Mall",
        distance: "20–25 Mins*"
      },
      {
        icon: "Trophy",
        place: "Sports Stadium",
        distance: "15–20 Mins*"
      },
      {
        icon: "GraduationCap",
        place: "International School",
        distance: "10–15 Mins*"
      }
    ]
  }
};
